import React from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import Download from 'components/shared/Icon/icons/Download';
import Visibility from 'components/shared/Icon/icons/Visibility';
import Loader from 'components/shared/Loader';
import Tooltip from 'components/shared/Tooltip';
import i18n from 'i18n';
import { ASSET_SIZE_TYPES, getAssetSrcFromId } from 'utils/asset';

import s from './index.module.css';
import { IItemProps } from './types';
import { useItem } from './useItem';

export function Item(props: IItemProps) {
  const { file } = props;
  const { onDownload, onPreview, isDownload, isPreview } = useItem(props);

  return (
    <div className={s.wrapper}>
      <a
        href={getAssetSrcFromId(file.id, ASSET_SIZE_TYPES.FULL)}
        target="_blank"
        rel="noopener noreferrer"
        className={s.name}
        data-tip
        data-for={`landing_pdf_open_btn_${file.id}`}
        data-document-id={file.id}
        data-document-type={file.mimeType}
        data-document-file={file.name}
        data-document-action={'open'}
      >
        {file.name}
      </a>
      <Tooltip id={`landing_pdf_open_btn_${file.id}`}>{i18n.t('proposal_content.file.click_to_open')}</Tooltip>
      <div className={s.actions}>
        {isDownload ? (
          <Loader width={49 / 3.7} height={52 / 3.7} iconClassName={s.loader} />
        ) : (
          <button
            className={s.downloadBtn}
            data-document-id={file.id}
            data-document-type={file.mimeType}
            data-document-uri={getAssetSrcFromId(file.id, ASSET_SIZE_TYPES.FULL)}
            data-document-file={file.name}
            data-document-action={'download'}
          >
            <Icon
              component={Download}
              className={cx(s.icon, s.downloadIcon)}
              onClick={() => onDownload(file)}
              data-tip
              data-for={`landing_pdf_download_btn_${file.id}`}
            />
            <Tooltip id={`landing_pdf_download_btn_${file.id}`}>
              {i18n.t('proposal_content.file.download_single_file')}
            </Tooltip>
          </button>
        )}
        {isPreview ? (
          <Loader width={49 / 3.7} height={52 / 3.7} iconClassName={s.loader} />
        ) : (
          <button
            className={s.previewBtn}
            data-document-id={file.id}
            data-document-type={file.mimeType}
            data-document-uri={getAssetSrcFromId(file.id, ASSET_SIZE_TYPES.PREVIEW)}
            data-document-file={file.name}
            data-document-action={'preview'}
          >
            <Icon
              component={Visibility}
              className={cx(s.icon, s.visibilityIcon)}
              onClick={() => onPreview(file)}
              data-tip
              data-for={`landing_pdf_preview_btn_${file.id}`}
            />
            <Tooltip id={`landing_pdf_preview_btn_${file.id}`}>{i18n.t('proposal_content.file.preview')}</Tooltip>
          </button>
        )}
      </div>
    </div>
  );
}
